import { useEffect, useRef, useState } from 'react'

import { motion } from 'framer-motion'

export default function VideoPlayer({
  src,
  onPercentageWatchedMilestone,
}: {
  src: string
  onPercentageWatchedMilestone?(milestone: number, video: HTMLVideoElement): void
}) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const milestonesRef = useRef<Set<number>>(new Set())
  const [videoLoaded, setVideoLoaded] = useState(false)

  useEffect(() => {
    const video = videoRef.current
    if (!video || !onPercentageWatchedMilestone) return

    const handleTimeUpdate = () => {
      if (!video.duration) return
      ;[0, 25, 50, 75, 100].forEach((milestone) => {
        if (
          Math.round((video.currentTime / video.duration) * 100) >= milestone &&
          !milestonesRef.current.has(milestone)
        ) {
          onPercentageWatchedMilestone(milestone, video)
          milestonesRef.current.add(milestone)
        }
      })
    }

    video.addEventListener('timeupdate', handleTimeUpdate)
    return () => video.removeEventListener('timeupdate', handleTimeUpdate)
  }, [])

  return (
    <motion.video
      ref={videoRef}
      controls
      src={src}
      initial={{ opacity: 0 }}
      animate={{ opacity: videoLoaded ? 1 : 0 }}
      transition={{ duration: 0.3 }}
      onLoadedData={() => setVideoLoaded(true)}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block'
      }}
    />
  )
}
